import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import SvgIcon from "@material-ui/core/SvgIcon";

import {withEuroOrDash} from "../../../../../../../../../utils/utils";
import AssetBaseInfo from "../../../../../AssetCard/components/AssetBaseInfo";

import styles from "./styles";

const SelectAssetCard = ({classes, item, categoryIcon, handleCheckboxChange}) => {
  return (
    <div className={classes.assetCard}>
      <Grid container spacing={2} alignItems={"center"}>
        {!!handleCheckboxChange && (
          <Grid item xs={'auto'}>
            <Checkbox
              className={classes.checkbox}
              checked={item.selected || false}
              onChange={handleCheckboxChange}
              color="primary"
            />
          </Grid>
        )}
        <AssetBaseInfo
          icon={!!item.icon ? <SvgIcon component={item.icon} /> : categoryIcon}
          subCategoryName={item.sub_category_display}
          assetName={item.name}
          expiredAt={item.is_expired && item.expiration_date}
          isFuture={item.is_future}
        />
        <Grid item xs={'auto'}><b>{withEuroOrDash(item.hasOwnProperty('asset_value') ? item.asset_value : item.value)}</b></Grid>
      </Grid>
    </div>
  )
};

export default withStyles(styles)(SelectAssetCard);